import { render, staticRenderFns } from "./buttonAssignLogistics.vue?vue&type=template&id=0e4d8659"
import script from "./buttonAssignLogistics.vue?vue&type=script&lang=ts"
export * from "./buttonAssignLogistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports